module.exports = __webpack_public_path__ + "media/images/application/social_sharing/facebook-685827de9381e3cff485cf8a03caf08f.png";